// extracted by mini-css-extract-plugin
export default {"codeInput":"CodeInput_codeInput__I78-k","character":"CodeInput_character__l4N5S","characterInactive":"CodeInput_characterInactive__-yV3U"};